export class RegistrationFind {
    id: number;
    districtAcctNumber: number;

    constructor() {
        this.id = 0;
        this.districtAcctNumber = 0;
    }
}